goog.provide('el8.appchart.dialog.saveTemplate');

goog.require('el8.appservice.notifier');
goog.require('el8.service.urls');
goog.require('el8.template.appchart.dialog.saveTemplate');
goog.require('el8.uiwidget.Form');
goog.require('el8.uiwidget.FormDialog');
goog.require('el8.util.consts');
goog.require('el8.util.validate');


/**
 * This file is currently responsible only for saving letter templates.
 * Ideally, it would also handle visitnote templates, but at the moment,
 * the files for those templates assume some facts unique to visinote checklists.
 * We didn't unify the files, since we'd have to throw out most of the unified
 * files anyways to produce searchable/ranked templates we actually like.
 */
 el8.appchart.dialog.saveTemplate = (function() {

    var successCb = null;
    var templateKeys = null;
    var templateSet = null;
    var urlKey = null;

    var that = new el8.uiwidget.FormDialog({
        title: 'Save New Template',
        modal: true,
        autoHeight: true,
        width: 400,
        contentFn: el8.template.appchart.dialog.saveTemplate.content,
        showXButton: el8Globals.READ_ONLY
    });

    var form = new el8.uiwidget.Form({
        fields: [
            {
                name: 'name',
                type: 'input',
                infoText: 'name...',
                maxLength: 30,
                validate: { required: true}
            }
        ],
        validationOpts: el8.util.validate.standardOpts
    });

    form.addSaveButton(function() {
       if (!form.isValid()) {
           el8.uiwidget.alert('Please enter a name for this template.');
           return;
       }
       form.disable();
       saveFn();
    }, true);
    form.addDiscardButton(function() {
       that.hide();
    });

    that.setForm(form);
    
    var super_show = that.show;
    that.show = function(opts) {
        super_show.call(that);
        templateKeys = opts.templateKeys;
        templateSet = opts.templateSet;
        urlKey = opts.urlKey;
        successCb = opts.successCb;
    };
    
    var super_hide = that.hide;
    that.hide = function() {
       form.enable();
       super_hide.call(that);
       successCb = null;
       templateKeys = null;
       templateSet = null;
       urlKey = null;
    };

    function saveFn() {
        var name = form.getVal('name');

        $.el8_ajax({
            type: 'GET',
            url: el8.service.urls.get(urlKey),
            data: { name: name },
            success: function(data) {
                if (data && data.id) {
                    el8.uiwidget.confirm(
                        "There's already a Template with the name \""+data.name +
                            ".\"  Do you want to replace the existing template?",
                        function() {
                            doPost(data.id);
                        },
                        function() {
                            el8.appservice.notifier.clear();
                            that.hide();
                        }
                    );
                } else {
                    doPost();
                }
            }
        });
    }

    function doPost(templateId) {
        el8.appservice.notifier.notify('Creating new template...');

        var data = _.clone(templateKeys);
        data['name'] = form.getVal('name');

        $.el8_ajax({
            type: 'POST',
            url: el8.service.urls.get(urlKey, [templateId]),
            data: JSON.stringify(data),
            success: function(data) {
                el8.appservice.notifier.notify('New template created.');
                templateSet.load(); // reload the whole set so the server can enforce ordering
                if (successCb) { successCb(); }
                that.hide();
            }
        });
    }

    return that;

})();